import React from "react";
import { Typography, TypographyProps } from "@mui/material";
import styles from "./styles";

export const Label = (props: TypographyProps) => <Typography sx={styles.label} {...props} />;
